import { Skeleton } from '@purpur/library';
import styled from 'styled-components';

import { PlanCardGrid } from '../../PlanCardGrid/PlanCardGrid';

export const PlansListSkeletonGrid = styled(PlanCardGrid)`
    *:nth-child(2),
    *:nth-child(3) {
        display: none;
    }

    @container plans-grid (min-width: 54rem) {
        *:nth-child(2) {
            display: block;
        }
    }

    @container plans-grid (min-width: 72rem) {
        *:nth-child(3) {
            display: block;
        }
    }
`;

export const PlansCardSkeleton = styled(Skeleton)`
    height: 40rem;
`;
